export const categoryInfos = [
    
        {
           
            title: "Electronics",
            name: "electronics",
            image: "https://m.media-amazon.com/images/I/51I02rhdhGL._SR480,440_.jpg",  
    },
    {
   
        title: "Jewelery",
        name: "jewelery",
        image: "https://fakestoreapi.com/img/61sbMiUnoGL._AC_UL640_QL65_ML3_.jpg",
         
     },
     {
        title: "Men's clothing",
        name: "men's clothing",
        image: "https://m.media-amazon.com/images/I/81D+bCgn8hL._AC_SY200_.jpg",
     },
     {
        title: "Women's clothing",
        name: "women's clothing",
        image: "https://fakestoreapi.com/img/81XH0e8fefL._AC_UY879_.jpg",
     }
]